class VideoPopup {
  constructor() {
    this.init();
  }

  init() {
    this.setupVideoButtons();
  }

  setupVideoButtons() {
    const videoButtons = document.querySelectorAll('.video-popup__open');

    videoButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const popupId = button.getAttribute('data-popup-id');
        if (popupId) {
          this.openVideoPopup(popupId);
        }
      });
    });
  }

  setupVideoPopup(popupID) {
    const popup = document.getElementById(popupID);
    const overlay = popup?.querySelector('.video-popup__overlay');
    const closeBtn = popup?.querySelector('.video-popup__close');

    if (overlay) {
      overlay.addEventListener('click', (e) => {
        // Only close if clicking directly on the overlay, not on the video content
        if (e.target === overlay) {
          this.closeVideoPopup(popupID);
        }
      });
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        this.closeVideoPopup(popupID);
      });
    }

    // Close popup on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.closeVideoPopup(popupID);
      }
    });
  }

  openVideoPopup(popupID) {
    const popup = document.getElementById(popupID);

    if (popup ) {
      this.setupVideoPopup(popupID);

      // Show the popup
      popup.style.display = 'flex';
      
      // Prevent body scroll
      document.body.style.overflow = 'hidden';
      
      // Focus management for accessibility
      popup.focus();
    }
  }

  closeVideoPopup(popupID) {
    const popup = document.getElementById(popupID);

    if (popup) {
      // Pause HTML5 video if present
      const video = popup.querySelector('video');
      if (video) {
        video.pause();
      }
      
      // Stop iframe video (YouTube/Vimeo) by clearing the src
      const iframe = popup.querySelector('iframe');
      if (iframe) {
        iframe.src = '';
      }
      
      // Hide the popup
      popup.style.display = 'none';
      
      // Restore body scroll
      document.body.style.overflow = '';
    }
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new VideoPopup();
});

// Also initialize if script is loaded after DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new VideoPopup();
  });
} else {
  new VideoPopup();
}
